module.exports = __webpack_public_path__ + "static/media/CA.2251010c.png";